// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1kCnS","label":"Radio_label__2N7P3","checkMark":"Radio_checkMark__2ViFe","disabled":"Radio_disabled__3UiCo"};